const Plan = () => import('../views/ServeManage/plan/index.vue');
const newPlan = () => import('../views/ServeManage/plan/pages/addAndEdit.vue');
const Details = () => import('../views/ServeManage/plan/pages/details.vue');
const List = () => import('../views/ServeManage/list/index.vue');
const Listdetails = () => import('../views/ServeManage/list/pages/addAndEdit.vue');
const Statistic = () => import('../views/ServeManage/statistics/index.vue');

export default [
  {
    path: '/plan',
    name: '任务列表',
    component: Plan,
    meta: [{ name: '任务列表' }],
  },
  {
    path: '/plan/add',
    name: '新增任务',
    component: newPlan,
    meta: [{ name: '任务列表', path: '/plan' }, { name: '新增任务' }],
  },
  {
    path: '/plan/edit',
    name: '编辑任务',
    component: newPlan,
    meta: [{ name: '任务列表', path: '/plan' }, { name: '编辑任务' }],
  },
  {
    path: '/plan/details',
    name: '查看任务',
    component: Details,
    meta: [{ name: '任务列表', path: '/plan' }, { name: '查看任务' }],
  },

  {
    path: '/list',
    name: '任务清单',
    component: List,
    meta: [{ name: '任务清单' }],
  },
  {
    path: '/list/details',
    name: '查看任务清单',
    component: Listdetails,
    meta: [{ name: '任务清单', path: '/list' }, { name: '查看任务清单' }],
  },
  {
    path: '/statistics',
    name: '任务统计',
    component: Statistic,
    meta: [{ name: '任务统计' }],
  },
];
